import { render, staticRenderFns } from "./ActiveSubmitSuccess.vue?vue&type=template&id=31afec30"
import script from "./ActiveSubmitSuccess.vue?vue&type=script&lang=js"
export * from "./ActiveSubmitSuccess.vue?vue&type=script&lang=js"
import style0 from "./ActiveSubmitSuccess.vue?vue&type=style&index=0&id=31afec30&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports